import React from 'react';
import { observer } from 'mobx-react-lite';

import { Step } from '../../../app/entities/step';
import { HeaderSimpleWidget } from './header-simple-widget';
import { WeatherWidget } from './weather-widget';
import { InfoWidget } from './info-widget';
import { Project } from '../../../app/entities/project';

import styles from './shooting-day-header.module.scss';
interface TopShootingDayProps {
  project: Project;
  step: Step;
}

export const ShootingDayHeader: React.FC<TopShootingDayProps> = observer(({ project, step }) => {
  const handleUpdatePolice = async (values: any) => {
    return step.update({
      info: {
        police: values,
      },
    });
  };

  const handleUpdateHospital = async (values: any) => {
    return step.update({
      info: {
        hospital: values,
      },
    });
  };

  const handleUpdateProduction = async (values: any) => {
    return project.update({
      production: values,
    });
  };

  return (
    <div className={styles['widget-grid']}>
      <div className={styles['grid-row-wrapper']}>
        <HeaderSimpleWidget
          project={project}
          text={'Client'}
          src={project.client?.logo?.src || ''}
        />

        <div className={styles['middle-widget-container']}>
          <HeaderSimpleWidget
            project={project}
            text={'Agency'}
            src={project.agency?.logo?.src || ''}
          />
        </div>

        <HeaderSimpleWidget
          project={project}
          text={'Production'}
          src={project.production?.logo?.src || ''}
        />
      </div>

      <div className={styles['grid-row-wrapper']}>
        <WeatherWidget step={step} />
      </div>

      <div className={styles['grid-row-wrapper']}>
        <InfoWidget
          stepId={step._id}
          title="Police"
          onUpdate={handleUpdatePolice}
          info={step.info?.police || {}}
        />

        <div className={styles['middle-widget-container']}>
          <InfoWidget
            stepId={step._id}
            title="Hospital"
            onUpdate={handleUpdateHospital}
            info={step.info?.hospital || {}}
          />
        </div>

        <InfoWidget
          stepId={step._id}
          title="Production company"
          onUpdate={handleUpdateProduction}
          info={project.production || {}}
        />
      </div>
    </div>
  );
});
